<div
  style="page-break-inside: avoid;"
  class="mt-4"
  *ngIf="incomeFormRentData.length > 0"
  [ngClass]="{
    'container': true,
    'return-view-background-print': printActive,
    'return-view-background': !printActive
  }"
>
  <div class="row mb-4">
    <div class="col-12 text-center">
      <strong>PARTICULARS OF INCOME FROM RENT</strong>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <strong>Taxpayer Name:</strong> {{ returnData?.profileData?.assesName }}
    </div>
    <div class="col-sm-6 text-right">
      <strong>Assessment Year:</strong> {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>

  <div class="row mt-3 mb-5">
    <div class="col-sm-12">
      <strong>TIN</strong>
      <span class="ml-3" style="white-space: nowrap;">
        <input
          value="{{ tinChar }}"
          *ngFor="let tinChar of ((returnData?.profileData?.tin || '') + '').split('')"
          class="input-default"
          disabled
        />
      </span>
    </div>
  </div>

  <div *ngFor="let item of incomeFormRentData; let idx = index" style="page-break-inside: avoid;" class="row mb-5">
    <div class="col-12 mb-4 return-view-section-title">
      Property {{ idx + 1 }}
    </div>

    <div class="col-12 mb-3">
      <div class="return-view-text-fields">
        <div class="return-view-text-field" *ngFor="let field of getTextParticulars(item)">
          <span class="return-view-text-label">{{ getTextFieldTitle(field) }}:</span>
          <span class="return-view-text-value">{{ getTextFieldDisplayValue(item, field) }}</span>
        </div>
      </div>
    </div>

    <ng-container *ngIf="isHouseProperty(item)">
      <div class="col-12 mb-4" *ngIf="getHousePropertyPairRows(item) as pairRows">
        <table class="table table-bordered income-rent-table" *ngIf="pairRows.length > 0">
          <thead>
            <tr class="text-center">
              <th style="width: 50%">Particulars</th>
              <th style="width: 25%">Residential</th>
              <!-- <th style="width: 30%">Particulars (Commercial)</th> -->
              <th style="width: 25%">Commercial</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of pairRows">
              <td>{{ row.residentialTitle }}</td>
              <td class="text-right pr-3">
                <ng-container *ngIf="hasValue(item, row.residentialKey)">
                  <span *ngIf="isSqFtKey(row.residentialKey)">{{ getPairCellDisplayValue(item, row.residentialKey) }}</span>
                  <span *ngIf="!isSqFtKey(row.residentialKey)">{{ getValue(item, row.residentialKey) | currencySeparatorBD }}</span>
                </ng-container>
              </td>
              <!-- <td>{{ row.commercialTitle }}</td> -->
              <td class="text-right pr-3">
                <ng-container *ngIf="hasValue(item, row.commercialKey)">
                  <span *ngIf="isSqFtKey(row.commercialKey)">{{ getPairCellDisplayValue(item, row.commercialKey) }}</span>
                  <span *ngIf="!isSqFtKey(row.commercialKey)">{{ getValue(item, row.commercialKey) | currencySeparatorBD }}</span>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12" *ngIf="getHousePropertyOtherParticulars(item) as otherRows">
        <table class="table table-bordered income-rent-table" *ngIf="otherRows.length > 0">
          <thead>
            <tr class="text-center">
              <th style="width: 70%">Particulars</th>
              <th style="width: 30%">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let particular of otherRows">
              <td>{{ particular.title }}</td>
              <td class="text-right pr-3">{{ getValue(item, particular.key) | currencySeparatorBD }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <div class="col-12" *ngIf="isOtherProperty(item) && getOtherPropertyParticulars(item) as rows">
      <table class="table table-bordered income-rent-table" *ngIf="rows.length > 0">
        <thead>
          <tr class="text-center">
            <th style="width: 70%">Particulars</th>
            <th style="width: 30%">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let particular of rows">
            <td>{{ particular.title }}</td>
            <td class="text-right pr-3">{{ getValue(item, particular.key) | currencySeparatorBD }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-12 mt-4" *ngIf="getSpecialRentalIncomeParticulars(item) as specialRows">
      <ng-container *ngIf="specialRows.length > 0">
        <div class="text-center font-weight-bold mb-2">Special Rental Income</div>
        <table class="table table-bordered income-rent-table">
          <thead>
            <tr class="text-center">
              <th style="width: 70%">Particulars</th>
              <th style="width: 30%">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let particular of specialRows">
              <td>{{ particular.title }}</td>
              <td class="text-right pr-3">{{ getValue(item, particular.key) | currencySeparatorBD }}</td>
            </tr>
            <tr>
              <td>Total</td>
              <td class="text-right pr-3">{{ getTotalSpecialRentalIncome(item) | currencySeparatorBD }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>

    <!-- <div class="col-12 mt-4" *ngIf="getFinalIncomeParticulars(item) as finalRows">
      <table class="table table-bordered income-rent-table" *ngIf="finalRows.length > 0">
        <thead>
          <tr class="text-center">
            <th style="width: 70%">Particulars</th>
            <th style="width: 30%">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let particular of finalRows">
            <td>{{ particular.title }}</td>
            <td class="text-right pr-3">{{ getValue(item, particular.key) | currencySeparatorBD }}</td>
          </tr>
        </tbody>
      </table>
    </div> -->
  </div>
</div>
